import { Table } from "react-bootstrap";
import { formatNumberWithCommas } from "../../../../utils/utility";

export default function BankPayments({ payments = [] }) {
    return (
        <Table  striped bordered hover responsive>
            <thead className="table">
                <tr
                    style={{
                        position: "sticky",
                        top: 0,
                        backgroundColor: "white",
                    }}
                >
                    <th>S.No</th>
                    <th>Company Name</th>
                    <th>Invoice Number</th>
                    <th>Amount Paid</th>
                    <th>Created At</th>
                </tr>
            </thead>
            <tbody>
                {payments.length === 0 ? (
                    <tr>
                        <td colSpan={5} className="text-center">
                            No data available
                        </td>
                    </tr>
                ) : (
                    payments.map((data, index) => (
                        <tr key={data.id ?? index}>
                            <td>{index + 1}</td>
                            <td>{data?.company?.name || "-"}</td>
                            <td>
                                {data.payment?.invoice_id ? (
                                    <a
                                        href={`/tms/invoices/payments/${data?.payment?.invoice_id}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {data.invoice_number}
                                    </a>
                                ) : (
                                    data.invoice_number || "-"
                                )}
                                    
                            </td>
                            <td>${formatNumberWithCommas(data.amount_paid ?? 0)}</td>
                            <td>{data.created_at || "-"}</td>
                        </tr>
                    ))
                )}
            </tbody>
        </Table>
    );
}
